import { SVGProps, Ref, forwardRef } from 'react';

export const BanOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4.58 5.853C3.36 7.469 2.8 9.648 2.8 12c0 2.483.624 4.772 1.989 6.41C6.106 19.99 8.308 21.2 12 21.2c2.845 0 4.805-.718 6.157-1.77zm14.84 12.294C20.64 16.53 21.2 14.352 21.2 12c0-2.483-.624-4.772-1.989-6.41C17.894 4.01 15.692 2.8 12 2.8c-2.845 0-4.805.718-6.157 1.77zM1 12C1 6.5 3.75 1 12 1s11 5.5 11 11-2.75 11-11 11S1 17.5 1 12"
                fill="currentColor"
            />
        </g>
    </svg>
));
BanOutlinedSize24Glyph.displayName = 'BanOutlinedSize24Glyph';
